import {
  PROMOTION_CODE_API,
  PROMOTION_CODE_API_SEARCH,
} from "shared/constants/api-endpoint";
import { apiClient } from "shared/plugins/http-service";
import { PagedResult } from "states/paged-result-model";
import {
  PromotionCodeModel,
  SearchPromotionCodeRequestModel,
} from "./promotion-code.models";

export const searchPromotionCode = async (
  model: SearchPromotionCodeRequestModel
) => {
  const createResponse = await apiClient.postHttp<
    PagedResult<PromotionCodeModel>
  >(`${PROMOTION_CODE_API_SEARCH}`, model);
  return createResponse;
};

export const getPromotionCodeById = async (id: string) => {
  return await apiClient.getHttp<PromotionCodeModel>(
    `${PROMOTION_CODE_API}/${id}`
  );
};

export const addPromotionCode = async (model: PromotionCodeModel) => {
  const response = await apiClient.postHttp<number>(
    `${PROMOTION_CODE_API}`,
    model
  );
  return response;
};

export const updatePromotionCode = async (model: PromotionCodeModel) => {
  const response = await apiClient.putHttp<number>(
    `${PROMOTION_CODE_API}`,
    model
  );
  return response;
};
